import { ITerms } from '../../types/interfaces';

export function hasTerms<T>(obj: ITerms<T> = {} as ITerms<T>, val: T[]): boolean {
  return (obj.value || []).some(v => val.includes(v));
}
